import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor() {}

  get role():string{
    return sessionStorage.getItem('role');
  }

  get userId():number{
    return Number(sessionStorage.getItem('userId'));
  }

  isSuperVisor():boolean{
    return this.role == 'SUPERVISOR';
  }

  isTrainerUser():boolean{
    return this.role == 'TRAINER';
  }

  isTraineeUser():boolean{
    return this.role == 'TRAINEE';
  }

  isEndUser():boolean{
    return sessionStorage.getItem('displayRole') == 'ENDUSER';
  }
}
